import { Directive, Input, ViewContainerRef } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';

@Directive({selector: '[vcmUserNews]'})
export class UserNewsDirective {
	constructor(public viewContainerRef: ViewContainerRef) { }
}